<template>
    <p-secure :require-role="[SECURITYROLES.STOREMANAGER]">
        <p-search-screen
            title="Buyback Session Search"
            api-destination="buyback"
            :filters="filters"
            :filterBy="filterBy"
            :fields="sessionFields"
            :edit-url-func="item => `/buybacksessions/${item.buybackSessionId}`"
            ref="sessionSearch"
        >
            <template v-slot:actionButtons>
                <editSession
                    session-id="new"
                    @data-saved="updateSessionSearch()"
                />
            </template>

            <template v-slot:belowSearch>
                <p-form>
                    <b-row class="mt-4 me-2">
                        <b-col>
                        <p-checkbox
                            label="Open"
                            v-model="filters.open"
                        />
                        <p-checkbox
                            label="Closed"
                            class="ms-3"
                            v-model="filters.closed"
                        />
                        </b-col>
                    </b-row>
                </p-form>
            </template>
        </p-search-screen>
    </p-secure>
</template>

<script>
import editSession from '@/views/Buyback/EditSession.vue';
import { dateFormatter } from '../../components/Common/Formatters.js';
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';

export default {
    mixins: [SearchStorage],
    components: { editSession },
    props: {
        id: String
    },
    data() {
        return {
            sessionFields: [
                {
                    key: 'description',
                    label: 'Description',
                    sortable: true,
                    automaticSearch: true
                },
                {
                    key: 'purchaserName',
                    label: 'Purchaser',
                    sortable:true
                },
                {
                    key: 'createDate',
                    label: 'Create Date',
                    sortable: true,
                    formatter: dateFormatter,
                    automaticSearch: true,
                    sortByFormatted: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true,
                    automaticSearch: true
                }
            ],
            filterName: 'BuybackSessionFilter',
            filters: {
                automatic: "",
                perPage: 100,
                sortBy: 'description',
                sortDesc: true,
                searchBy: 'All',
                open: true,
                closed: false
            },
            filterBy: ['All', 'Description','Purchaser']
        };
    },

    computed: {},
    methods: {
        updateSessionSearch() {
            this.$refs?.sessionSearch.refreshSearchResults();
        }
    }
};
</script>
<style scoped lang="scss">
@import "@/styles/app/common/variables.scss";

:deep(.tcw100 ) {
    width: 100px;
}
</style>
